module.exports = __webpack_public_path__ + "img/6.66891735.png";